import { IQueryTypeFragments } from '~api/QueryFragments';
import { QueryType } from './Default';

const loyaltyLevelNextFragment = `
    on ${QueryType.loyaltyLevelNext} {
        level
        rbTierName
        needs {
          pointsMin
          spendMin
        }
    }
`;

export const loyaltyLevelNextFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.loyaltyLevelNext]: loyaltyLevelNextFragment
    };
};
